import { CardConfig } from "@/types";
import { DateUtils } from "@/helpers/DateUtils";

export const quoteCardConfig: CardConfig = {
  header: {
    icon: "spinner",
    iconSource: "$record.process.settings.icon",
    title: {
      source: "$record.custom_attributes.quote_number",
      formatter: (value) => `Número de cotización: ${value ?? "-"}`,
      classes: "text-gray-800 fw-bold col-12 fs-4",
    },
    subtitle: {
      source: "$record.process.name",
      classes: "text-gray-500 fw-bold col-12",
    },
  },
  body: [
    {
      id: "applicantsName",
      title: "Nombre del cliente",
      source: "$record.applicants_name",
      component: "card-info-row",
      classes: "bordered-bottom pb-2",
      fallback: "-",
      formatter: (value) => (value ? String(value).toUpperCase() : "-"),
    },
    {
      id: "identificationType",
      title: "Tipo de identificación",
      source: "$record.custom_attributes.identification_type.detalle",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
    },
    {
      id: "identificationNumber",
      title: "Número de identificación",
      source: "$record.custom_attributes.identification_number",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
    },
    {
      id: "quoteStatus",
      title: "Estado",
      source: "$record.grouped_tags.quote_status.0.name",
      component: "card-info-row",
      type: "vue-status-badge-v2",
      formatter: (value) => ({ label: value ?? "-", color: "color" }),
      classes: "bordered-bottom pb-2",
    },
    {
      id: "createdAt",
      title: "Fecha de creación",
      source: "$record.created_at",
      component: "card-info-row",
      fallback: "-",
      classes: "bordered-bottom pb-2",
      formatter: (value) => (value ? DateUtils.formatDateTime({ date: value }) : "-"),
    },
    {
      id: "createdBy",
      title: "Creado por",
      source: "$record.created_by.name",
      component: "card-info-row",
      fallback: "-",
      classes: "pb-2",
    },
  ],
  footer: {
    bordered: true,
    classes: "justify-content-between",
    actions: [
      {
        id: "delete",
        label: "Eliminar",
        icon: "trash",
        classes: "btn btn-secondary",
        event: "delete-record",
        conditions: [{ type: "can", values: [["applications-management.applications.delete"]] }],
      },
      {
        id: "continue",
        label: "Continuar",
        classes: "btn btn-danger",
        icon: "pen",
        to: { name: "EditCurrentStep", params: { id: "$record.id" } },
        conditions: [
          {
            type: "can",
            values: [["applications-management.applications.read"], ["applications-management.applications.update"]],
          },
          {
            type: "notIn",
            values: [
              "$record.grouped_tags.quote_status.0.id",
              [
                process.env.VUE_APP_FINISHED_QUOTE_STATUS_TAG,
                process.env.VUE_APP_DIGITAL_ACCEPTANCE_QUOTE_STATUS_TAG,
                process.env.VUE_APP_ACCEPTED_QUOTE_STATUS_TAG,
              ],
            ],
          },
        ],
      },
      {
        id: "view",
        label: "Ver",
        classes: "btn btn-danger",
        icon: "eye",
        to: { name: "ReadStep", params: { id: "$record.id", stepId: "0001" } },
        conditions: [
          { type: "can", values: [["applications-management.applications.read"]] },
          {
            type: "in",
            values: [
              "$record.grouped_tags.quote_status.0.id",
              [
                process.env.VUE_APP_FINISHED_QUOTE_STATUS_TAG,
                process.env.VUE_APP_DIGITAL_ACCEPTANCE_QUOTE_STATUS_TAG,
                process.env.VUE_APP_ACCEPTED_QUOTE_STATUS_TAG,
              ],
            ],
          },
        ],
      },
    ],
  },
};
